const baseStyle = {
    height: '38px',
    padding: '0px 16px',
    borderRadius: '999px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: 'transform 140ms ease, background 140ms ease, box-shadow 140ms ease',
};

const baseLabelStyle = {
    fontSize: '15px',
    fontWeight: '600',
    color: 'var(--app-text)',
    lineHeight: 'var(--app-line-height)',
};

const BlurPillButton = ({
    icon,
    label,
    type = 'button',
    className = '',
    style = {},
    labelStyle = {},
    children,
    ...buttonProps
}) => (
    <button
        type={type}
        className={['blurBackground', 'blurPillButton', className].filter(Boolean).join(' ')}
        style={{ ...baseStyle, ...style }}
        {...buttonProps}
    >
        {icon && (
            <span className='blurPillButtonIcon' style={{ fontSize: '15px', display: 'flex', alignItems: 'center', lineHeight: 0 }}>
                {icon}
            </span>
        )}
        {label !== undefined ? (
            <span className='blurPillButtonLabel' style={{ display: 'flex', alignItems: 'center', ...baseLabelStyle, ...labelStyle }}>
                {label}
            </span>
        ) : children}
    </button>
);

export default BlurPillButton;
